<template>
    <div class="af-login-widget-loggedout afu-border afu-border-solid afu-border-gray-300 afu-bg-gray-600 afu-bg-opacity-10 afu-p-2 afu-text-center afu-text-gray-600 afu-text-sm">
        <a :href="getLocationLink('/user-login')">Login</a> |
        <a :href="getLocationLink('/user-register')">Register</a>
    </div>
</template>

<script>
    export default {
        name: 'LoggedOut',

        data() {
            return {
            };
        },

        methods: {},
    };
</script>
